import { useDefaultHandleAxiosErrorProps, usePostMutation } from "hooks/useClientPortalQuery";
import { useClientPortalConfigContext } from "../../../context";
import { CustomFormSaveFailedApiDetailsErrorResponse, CustomFormViewModel } from "types/generated/models";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { ErrorProps, handleAxiosError } from "hooks/useClientPortalQuery.helpers";
import { useClientPortalNavigate } from "hooks/useClientPortalRouter";
import { ROUTES } from "../../../routes";

export interface IUseSaveForm {
    saveForm: (customFormViewModel: CustomFormViewModel) => Promise<string>;
}

export function useSaveForm(): IUseSaveForm {
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const defaultHandleAxiosErrorProps = useDefaultHandleAxiosErrorProps();
    const navigate = useClientPortalNavigate();

    const { mutateAsync } = usePostMutation<string, AxiosError, CustomFormViewModel>({
        url: `/api/v1/${clientPortalGuid}/CustomForm/Save`,
        handleCustomError: (error: AxiosError) => {
            const response = error.response?.data as CustomFormSaveFailedApiDetailsErrorResponse;
            if (response?.message) {
                enqueueSnackbar(response.message, {
                    variant: "error",
                    alertTitle: "Failed to save form",
                });

                if (response?.details?.redirect) {
                    if (clientPortalConfig?.userLoggedIn) {
                        navigate(ROUTES.FORMS.urlPath);
                    } else {
                        navigate(ROUTES.HOME.urlPath);
                    }
                }
            } else {
                handleAxiosError({ ...defaultHandleAxiosErrorProps, error } as ErrorProps);
            }
        },
    });

    return {
        saveForm: mutateAsync,
    };
}
